module.exports = __webpack_public_path__ + "static/media/caravan.19321e55.svg";